import {
  List,
  ListItem,
  ListItemText,
  Typography
  ,Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  getTasksRequest, resetDefects, resetLabours, resetMaterials
} from '../../store/actions';
import { removeBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { connect } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    maxHeight: '60vh'
  },
  listItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  }
}));

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

function NotificationList(props) {
  const classes = useStyles();
  const {
    notifications,
    onClickNotification,
    className,
    getTasksRequest,
    resetDefects,
    resetLabours,
    resetMaterials,
    tasks,
    ...rest
  } = props;

  const getTitle = (event, Title, InsertDate) => {
    return (
      <Typography color="primary" variant="h6">
        <span style={{ fontWeight: 'bold' }}>{Title}</span>
        <span style={{ fontSize: 'small', fontWeight: 'normal' }}> {bull} {InsertDate}</span>
      </Typography>
    );
  };

  const handleRefresh = () => {
    getTasksRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
    removeBaslandiJob();
  };

  function handleNotificationClick(workOrderId) {
    sessionStorage.setItem('WorkOrderId', workOrderId);
    handleRefresh();
    sessionStorage.removeItem('WorkOrderId');
  }

  return (
    <List {...rest} className={clsx(classes.root, className)} disablePadding>
      {notifications.map(not => (
        <div key={not.Id}>
          <ListItem
            style={{ backgroundColor: not.IsRead === true ? 'transparent' : '#f1f1f1' }}
            className={classes.listItem}
            divider={not < notifications.length - 1}
            onClick={() => handleNotificationClick(not.WorkOrderId)}
          >
            <ListItemText
              primary={getTitle(not, not.NotificationHeader, not.InsertDate)}
              primaryTypographyProps={{ variant: 'body1' }}
              secondary={
                <Typography
                  component="span"
                  variant="body2"
                  className={classes.inline}
                  color="textPrimary"
                >
                  {not.NotificationBody}
                </Typography>
              }
            />
          </ListItem>
        </div>
      ))}
    </List>
  );
}

NotificationList.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.array.isRequired,
  onClickNotification: PropTypes.func
};

export default connect(
  (state) => ({ tasks: state.tasks1 }),
  {
    getTasksRequest, resetDefects, resetLabours, resetMaterials
  }
)(NotificationList);
